import { render, staticRenderFns } from "./LifeStages.vue?vue&type=template&id=772be5b0&scoped=true&"
import script from "./LifeStages.vue?vue&type=script&lang=js&"
export * from "./LifeStages.vue?vue&type=script&lang=js&"
import style0 from "./LifeStages.vue?vue&type=style&index=0&id=772be5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772be5b0",
  null
  
)

export default component.exports